import { render, staticRenderFns } from "./RemoveDepthChartModal.vue?vue&type=template&id=9f672cae&"
import script from "./RemoveDepthChartModal.vue?vue&type=script&lang=js&"
export * from "./RemoveDepthChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports